import { createRequest, RequestConfig } from 'app/common/api';

import { TTrip } from '../core/trips';

const config: RequestConfig = {
  method: 'post',
  url: '/ws/api/update_trips',
};

export const updateTripsRequest = (trips: Partial<TTrip>[]) =>
  createRequest({
    url: config.url,
    method: config.method,
    body: JSON.stringify(trips),
  });
